<template>
    <main class="page-shell admin-shell">
        <section class="admin-heading">
            <span class="brand-kicker">Operator view</span>
            <h1 class="brand-title">Admin panel.</h1>
            <p class="brand-subtitle">Live platform telemetry, sessions, users, events, and system health.</p>
        </section>

        <AdminStatistics/>
        <AdminSystem/>
    </main>
</template>

<script>
import AdminStatistics from '@/components/AdminStatistics.vue';
import AdminSystem from '@/components/AdminSystem.vue';

export default {
    name: 'Admin',
    components: {
        AdminStatistics,
        AdminSystem,
    }
}
</script>

<style scoped>
.admin-shell {
    text-align: left;
}

.admin-heading {
    margin-bottom: 2rem;
    text-align: center;
}
</style>
